<template>
    <div>

        <div class="columns">
            <div class="column">

                <h3 class="title is-size-5">{{ $t('modules.positions.index.sendReportModal.evalChoiceTitle') }}</h3>
                <!-- <p>
                    {{ $t('modules.positions.index.sendReportModal.evalChoiceNotice') }}
                </p> -->
                <label class="label">
                    {{ $t('modules.positions.index.sendReportModal.evalsListTitle') }}
                </label>
                <!-- <div class="select_all_evals" @click="selectEvals">{{ $t('modules.positions.index.sendReportModal.evalsListSelectAll') }}</div> -->
                <div v-for="(evaluation) in completedEvaluations" :key="evaluation.id">
                    <div v-if="!evaluation.in_regen">
                        <input v-model="evalsIds" :value="evaluation" class="styled-checkbox" :id="'evaluation_' + evaluation.id" type="checkbox" @change="sendDatas">
                        <label :for="'evaluation_' + evaluation.id">{{ evaluation.candidate_username }}</label>
                    </div>
                    <div class="eval_input_in_regen" v-else>
                        <span>{{ evaluation.candidate_username }} - Rapports en cours de regénération</span>
                    </div>
                </div>

            </div>
            <div class="column evaluations_choice_column">
                <div class="report_radios radio_input">
                    <label class="label">{{ $t('modules.positions.index.sendReportModal.evalChoiceRadioLabel') }}</label>
                    <div>
                        <input v-model="reportType" value="expert"  type="radio" id="expert_report_radio" name="radio-group" @change="sendDatas">
                        <label for="expert_report_radio">{{ $t('modules.positions.index.sendReportModal.evalChoiceRadioValue1') }}</label>
                    </div>
                    <div>
                        <input v-model="reportType" value="manager"  type="radio" id="manager_report_radio" name="radio-group" @change="sendDatas">
                        <label for="manager_report_radio">{{ $t('modules.positions.index.sendReportModal.evalChoiceRadioValue2') }}</label>
                    </div>
                    <div>
                        <input v-model="reportType" value="candidate"  type="radio" id="candidate_report_radio" name="radio-group" @change="sendDatas">
                        <label for="candidate_report_radio">{{ $t('modules.positions.index.sendReportModal.evalChoiceRadioValue3') }}</label>
                    </div>
                    <div>
                        <input v-model="reportType" value="customer"  type="radio" id="customer_report_radio" name="radio-group" @change="sendDatas">
                        <label for="customer_report_radio">{{ $t('modules.positions.index.sendReportModal.evalChoiceRadioValue4') }}</label>
                    </div>
                </div>

                <button @click="changeStep" :disabled="evalsIds.length == 0" class="button is-info is-outlined">
                    {{ $t('modules.positions.index.sendReportModal.evalChoiceValidationButton') }}
                </button>
            </div>
        </div>

    </div>
</template>

<script>


export default {
    name: 'SendReportEvalChoice',
    components: {

    },
    data(){
        return {
            evalsIds: [],
            reportType: 'expert'
        }
    },
    computed: {
        currentPosition(){
            return this.$store.state.PositionStore.currentPosition
        },
        evaluations(){
            if(this.currentPosition){
                return this.currentPosition.evaluations
            }
        },
        completedEvaluations(){
            if(this.evaluations){
                return this.evaluations.filter((evaluation) => {
                    return evaluation.completed == true
                })
            }
        }
    },
    methods: {
        selectEvals(){
            this.evalsIds = this.evaluations
        },
        sendDatas(){
            this.$emit('evalChoiceChanged', this.evalsIds, this.reportType)
        },
        changeStep(){
            this.$emit('goStep2')
        }
    }
}
</script>

<style lang="scss" >
.report_radios{
    margin: 18px 0;
}
.evaluations_choice_column{
    border-left: 1px solid $grey-lighter;
}
.select_all_evals{
    margin: 0 0 18px;
    cursor: pointer;
    font-style: italic;
    &:hover{
        color: $info;
    }
}
.eval_input_in_regen{
    padding-left: 28px;
    color: $danger;
    &:before{
        content: " ";
        height: 18px;
        width: 18px;
        background: #bfbfbf;
        display: inline-block;
        position: absolute;
        margin-left: -28px;
        border-radius: 3px;
    }
}
</style>